// Next.js client instrumentation (runs once before hydration on every page).
// Jobs: DSN-gated Sentry browser init (sentry.client.config.ts) and the
// `x-request-id` fetch wrapper that pairs browser and backend error events
// (ENG-36, lib/request-id-client.ts — runs with or without Sentry).
// openspec: iso27001-soc2-readiness task 1.4, security-controls-round-4 A4,
// observability-failure-taxonomy
//
// MUST NOT import lib/env (server schema) — env validation is wired into
// instrumentation.ts (server only). This file ships in the client bundle.
import { installRequestIdHeader } from './lib/request-id-client';
import { initSentryClient } from './sentry.client.config';
import { config as configureZod } from 'zod/v4/core';
import { configureStyleNonce } from './lib/csp-style-runtime';

// Strict CSP intentionally forbids eval. Disable Zod's optional JIT before
// application schemas initialize, including its otherwise caught Function probe.
configureZod({ jitless: true });
configureStyleNonce();
installRequestIdHeader();
initSentryClient();

/**
 * Router-transition hook required by `withSentryConfig` (next.config.js, only
 * active when SENTRY_AUTH_TOKEN is set). Kept lazy + DSN-gated so deployments
 * without Sentry still pay no bundle cost.
 */
export const onRouterTransitionStart: (
  ...args: Parameters<
    typeof import('@sentry/nextjs').captureRouterTransitionStart
  >
) => void = (...args) => {
  if (!process.env.NEXT_PUBLIC_SENTRY_DSN) return;
  import('@sentry/nextjs')
    .then((Sentry) => Sentry.captureRouterTransitionStart(...args))
    .catch(() => {
      /* best-effort */
    });
};
